export default "__VITE_ASSET__127PxHRk__"